import api from '../core/api';
import {SaveData} from '../utils/Storage';

const authenticate = async credentials => {
  const {status, data} = await api.post('/auth/login/admin', credentials);
  const {token, user} = data;
  api.token = token;
  localStorage.setItem('token', token);
  localStorage.setItem('empresa_id', user.empresa_id || null);
  localStorage.setItem('user_id', user.id || null);
  localStorage.setItem('adminGestor', user.adminMaster);

  SaveData('business', {
    business_id: user.business_id,
    business_user: user.business_user,
    business_user_manager: user.business_user_manager,
    adminMaster: user.adminMaster,
    isAdmin: user.isAdmin,
  });

  if (!user.adminMaster) {
    window.location.reload('usuarios-empresa');
  }

  // if (credentials.email === 'teste@gmail.com') {
  //   //mock teste
  //   localStorage.setItem('idEmpresa', 7);
  //   localStorage.setItem('adminGestor', false);
  // }
};

export default {authenticate};
